<template>
  <div id="container">
    <div class="box" >

      <div class="box_one" style="margin-bottom:5px"> 
        <cont-top/>
      </div>

      <router-link :to="{ path: '/variousproducts/brakePads'  }">
        <div class="box_one" style="margin-bottom:5px"> 
          <cont-two/>
        </div>
      </router-link>

      <router-link :to="{ path: '/variousproducts/brakedisc'  }">
        <div class="box_one" style="margin-bottom:5px"> 
          <cont-three/>
        </div>
      </router-link>

      <router-link :to="{ path: '/variousproducts/brakecalipers'  }">
        <div class="box_one" style="margin-bottom:5px"> 
          <cont-four/>
        </div>
      </router-link>


      <router-link :to="{ path: '/variousproducts/brakeOil'  }">
        <div class="box_one" style="margin-bottom:5px"> 
          <cont-five/>
        </div>
      </router-link>

      <router-link :to="{ name: 'Other' }">
        <div class="box_one" style="margin-bottom:5px"> 
          <cont-six/>
        </div>
      </router-link>

      <!-- <div class="box_one" style="margin-bottom:5px"> 
        <cont-seven/>
      </div> -->
      <div class="box_one" > 
        <cont-bottom/>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// import ContOne from '@/'
import ContTop from '@/views/BrakeComponent/cont_one'
import ContTwo from '@/views/BrakeComponent/cont_two'
import ContThree from '@/views/BrakeComponent/cont_three'
import ContFour from '@/views/BrakeComponent/cont_four'
import ContFive from '@/views/BrakeComponent/cont_five'
import ContSix from '@/views/BrakeComponent/cont_six'
import ContSeven from '@/views/BrakeComponent/cont_seven'
import ContBottom from '@/views/Components/Cont_bottom'

export default {
  name: 'Brake',
  components: {
    ContTop ,
    ContTwo ,
    ContThree  ,
    ContFour ,
    ContFive ,
    ContSix ,
    ContSeven ,
    ContBottom
  } ,
  methods : {

  } ,
  mounted (){
  }
}
</script>

<style lang="stylus" scoped>
#container
  background-color : #000;
  overflow-x : hidden ;
.box 
  width: 1003px;
  background-color : #fff;
  margin 0 auto

</style>